export { default as withChapter } from './withChapter'
export { default as withLesson } from './withLesson'
export { default as withPage } from './withPage'
export { default as withHome } from './withHome'
export { default as withEndtest } from './withEndtest'
